import React from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import {Container, Button, Flex, Text, Box, Link, Modal, ModalOverlay, useDisclosure,
    ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, useToast} from '@chakra-ui/react';
import { booksItems } from "../DATABASE/publicationsBooks";
import { journalItems } from "../DATABASE/publicationsJournal";
import { conferenceItems } from "../DATABASE/publicationsConference";
import { chaptersItems } from "../DATABASE/publicationsChapters";

function publicationList() {

    // Refs to your section anchors
    const booksRef = useRef(null);
    const journalRef = useRef(null);
    const conferenceRef = useRef(null);
    const chaptersRef = useRef(null);
    const thesesRef = useRef(null);
    const toast = useToast();

    const scrollToRefWithOffset = (ref) => {
    const offsetInPixels = 85; // ~3cm on most screens (96px = 1 inch)
    if (ref && ref.current) {
      const top = ref.current.getBoundingClientRect().top + window.pageYOffset - offsetInPixels;
      window.scrollTo({ top, behavior: 'smooth' });
        }
    };

    const {isOpen, onOpen, onClose } = useDisclosure();
    const [activeBib, setActiveBib,] = useState('');
    const [activeText, setActiveText] = useState('');

    const handleBibClick = (bib, text) => {
        setActiveBib(bib);
        setActiveText(text);
        onOpen(); // opens modal
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(activeBib).then(() => {
            toast({
                title: 'Copied to your clipboard!',
                status: 'success',
                duration: 2000,
                isClosable: true,
                position: 'top-right',
            });
        });
    };

    return (
        <>
            {/* Header Section */}

            {/*
            <Container maxW="1000px" py={5}>
                <Flex justify="center" mt={4} gap={2} wrap="wrap">
                    <Button as="a" href="#books" variant="outline" bg="gray.200" boxShadow="md">
                        Books
                    </Button>
                    <Button as="a" href="#journal-articles" variant="outline" bg="gray.200" boxShadow="md">
                        Journal Articles
                    </Button>                    
                    <Button as="a" href="#conference-papers" variant="outline" bg="gray.200" boxShadow="md">
                        Conference Papers
                    </Button>
                    <Button as="a" href="#book-chapters" variant="outline" bg="gray.200" boxShadow="md">
                        Book Chapters
                    </Button>
                    <Button as="a" href="#theses" variant="outline" bg="gray.200" boxShadow="md">
                        Theses
                    </Button>
                </Flex>
            </Container>

            window.scrollTo({ top, behavior: 'smooth' });
            */}


            <Container maxW="1000px" py={5}>
            
                <Flex justify="center" mt={4} gap={2} wrap="wrap">
                    <Button
                        onClick={() => {
                            const target = document.getElementById("books");
                            const offset = 85; // ~3 cm
                            if (target) {
                            const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                            window.scrollTo({ top, behavior: 'auto' });
                            }
                        }}
                        variant="outline"
                        bg="gray.200"
                        boxShadow="md"
                        >
                        Books
                    </Button>
                    <Button
                        onClick={() => {
                            const target = document.getElementById("journal-articles");
                            const offset = 85; // ~3 cm
                            if (target) {
                            const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                            window.scrollTo({ top, behavior: 'auto' });
                            }
                        }}
                        variant="outline"
                        bg="gray.200"
                        boxShadow="md"
                        >
                        Journal Articles
                    </Button>
                    <Button
                        onClick={() => {
                            const target = document.getElementById("conference-papers");
                            const offset = 85; // ~3 cm
                            if (target) {
                            const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                            window.scrollTo({ top, behavior: 'auto' });
                            }
                        }}
                        variant="outline"
                        bg="gray.200"
                        boxShadow="md"
                        >
                        conference Papers
                    </Button>
                    <Button
                        onClick={() => {
                            const target = document.getElementById("book-chapters");
                            const offset = 85; // ~3 cm
                            if (target) {
                            const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                            window.scrollTo({ top, behavior: 'auto' });
                            }
                        }}
                        variant="outline"
                        bg="gray.200"
                        boxShadow="md"
                        >
                        Book Chapters
                    </Button>
                    <Button
                        onClick={() => {
                            const target = document.getElementById("theses");
                            const offset = 85; // ~3 cm
                            if (target) {
                            const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                            window.scrollTo({ top, behavior: 'auto' });
                            }
                        }}
                        variant="outline"
                        bg="gray.200"
                        boxShadow="md"
                        >
                        Theses
                    </Button>
                </Flex>

            </Container>

            {/* Publication Section */}
            <Container maxW="1000px" py={5}>
                <Flex direction="column" align="left">

                    <Text fontSize="lg" fontWeight="bold" id="books">
                        Books <Link href="#" color="blue.500">(back)</Link>
                    </Text>

                    {booksItems.map((book, index) => (
                        <Box  key={index} mt={3}>
                            <Text as="span" fontWeight="bold">{book.index}.</Text>{" "}
                            <Text as="span">{book.text} </Text>
                            {book.doi ?  (<Link href={book.doi} style={{ color: 'blue' }} target="_blank"><u>[doi]</u></Link>) : null}
                            {" "}
                            {book.bib && (
                                <Link
                                    onClick={() => handleBibClick(book.bib, book.text)}
                                    color="blue.500"
                                    cursor="pointer"
                                >
                                    <u>[bib]</u>
                                </Link>
                            )}
                        </Box>
                    ))}

                </Flex>
            </Container>

            <Container maxW="1000px" py={5}>
                <Flex direction="column" align="left">

                    <Text fontSize="lg" fontWeight="bold" id="journal-articles">
                        Refereed Journal Articles <Link href="#" color="blue.500">(back)</Link>
                    </Text>

                    {journalItems.map((journal, index) => (
                        <Box  key={index} mt={3}>
                            <Text as="span" fontWeight="bold">{journal.index}.</Text>{" "}
                            <Text as="span">{journal.text} </Text>
                            {journal.doi ?  (<Link href={journal.doi} style={{ color: 'blue' }} target="_blank"><u>[doi]</u></Link>) : null}
                            {" "}
                            {journal.bib && (
                                <Link
                                onClick={() => handleBibClick(journal.bib, journal.text)}
                                color="blue.500"
                                cursor="pointer"
                                >
                                <u>[bib]</u>
                                </Link>
                            )}
                        </Box>
                    ))}

                </Flex>
            </Container>

            <Container maxW="1000px" py={5}>
                <Flex direction="column" align="left">

                    <Text fontSize="lg" fontWeight="bold" id="conference-papers">
                        Refereed Conference/Workshop Papers  <Link href="#" color="blue.500">(back)</Link>
                    </Text>

                    {conferenceItems.map((conference, index) => (
                        <Box  key={index} mt={3}>
                            <Text as="span" fontWeight="bold">{conference.index}.</Text>{" "}
                            <Text as="span">{conference.text} </Text>
                            {conference.doi ?  (<Link href={conference.doi} style={{ color: 'blue' }} target="_blank"><u>[doi]</u></Link>) : null}
                            {" "}
                            {conference.bib && (
                                <Link
                                onClick={() => handleBibClick(conference.bib, conference.text)}
                                color="blue.500"
                                cursor="pointer"
                                >
                                <u>[bib]</u>
                                </Link>
                            )}
                        </Box>
                    ))}

                </Flex>
            </Container>

            <Container maxW="1000px" py={5}>
                <Flex direction="column" align="left">

                    <Text fontSize="lg" fontWeight="bold" id="book-chapters">
                        Book Chapters  <Link href="#" color="blue.500">(back)</Link>
                    </Text>

                    {chaptersItems.map((chapters, index) => (
                        <Box key={index} mt={3}>
                            <Text as="span" fontWeight="bold">{chapters.index}.</Text>{" "}
                            <Text as="span">{chapters.text} </Text>
                            {chapters.doi ?  (<Link href={chapters.doi} style={{ color: 'blue' }} target="_blank"><u>[doi]</u></Link>) : null}
                            {" "}
                            {chapters.bib && (
                                <Link
                                onClick={() => handleBibClick(chapters.bib, chapters.text)}
                                color="blue.500"
                                cursor="pointer"
                                >
                                <u>[bib]</u>
                                </Link>
                            )}
                        </Box>
                    ))}

                </Flex>
            </Container>


            <Container  maxW="1000px" py={5}>
                <Flex direction="column" align="left">

                    <Text fontSize="lg" fontWeight="bold" id="theses">
                        Theses  <Link href="#" color="blue.500">(back)</Link>
                    </Text>

                    <Box mt={3} textAlign="justify">
                        <Text as="span" fontWeight="bold">Ph.D Thesis:</Text>{" "}
                        <Text as="span">
                            "Availability Constrained Routing and Wavelength Assignment and Survivability in Optical WDM Networks",
                            Burak Kantarci, May 2009, Istanbul Technical University, Institute of Science and Technology, Computer Engineering Program.
                            (Supervisors:{" "}
                            <Link href="http://web.itu.edu.tr/oktug/" style={{ color: 'blue', textDecoration:'underline' }} isExternal>Dr. Sema Oktug</Link>, ITU, and{" "}
                            <Link href="http://www.site.uottawa.ca/~mouftah" style={{ color: 'blue', textDecoration:'underline' }} isExternal>Dr. Hussein T. Mouftah</Link>, University of Ottawa).
                    
                        </Text>
                    </Box>
                    
                    <Box mt={3} textAlign="justify">
                        <Text as="span" fontWeight="bold">M.Sc Thesis:</Text>{" "}
                        <Text as="span">
                            "<i>Performance Comparison and Traffic Analysis in Optical-Burst Switched Networks</i>",
                            Burak Kantarci, January 2005, Istanbul Technical University, Institute of Science and Technology, Computer Engineering Program.
                            (Supervisor: <Link href="http://web.itu.edu.tr/oktug/" style={{ color: 'blue', textDecoration:'underline' }} isExternal>Dr. Sema Oktug</Link>, ITU).
                        </Text>
                    </Box>



                </Flex>
            </Container>

            {/* Modal for displaying Bib content */}
            <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
                <ModalOverlay />
                <ModalContent maxW="800px" maxH="600px">
                    <ModalHeader fontSize="lg">BibTeX Entry</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody overflowY="auto">
                        {/* ADD: text preview at the top */}
                        <Box fontSize="md" mb={4} fontWeight="medium">
                            {activeText}
                        </Box>

                        {/* EXISTING: bibtex block */}
                        <Box
                            fontFamily="monospace"
                            whiteSpace="pre-wrap"
                            fontSize="sm"
                            lineHeight="1.4"
                        >
                            {activeBib}
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="blue" onClick={handleCopy}>
                            Copy
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

        </>
    );

}




export default publicationList;
